<template>
  <div class="login bg-primary fill-height overflow-x-auto">
    <v-layout align-center justify-center fill-height>
      <register-form
        v-if="!$route.query.id"
        :on-request="signUp"
        :on-response="response"
        :on-cancel="onCancel"
        :form-desc="formDesc"
        :img-logo="cliente.imgLogo"
      />
      <register-login-form
        v-if="$route.query.id"
        :uid="$route.query.id"
        :type="$store.state.context"
        :on-request="registerSignIn"
        :on-response="responseRegisterSignIn"
        :img-logo="cliente.imgLogo"
      />
    </v-layout>
  </div>
</template>

<script>
import RegisterForm from "@/components/forms/register-form";
import RegisterLoginForm from "@/components/forms/register-login-form";
import i18next from "i18next";

export default {
  metaInfo: {
    titleTemplate: `${i18next.t("cadastro") || ""} | %s`,
  },
  components: { RegisterLoginForm, RegisterForm },
  computed: {
    formDesc() {
      const textDefault = this.$t("preencha_formulario_cadastrar");
      let textContext = "";
      switch (this.$store.state.context) {
        case "pessoa":
          textContext = this.$t("seu_bracelete");
          break;
        case "pet":
          textContext = this.$t("seu_pingente");
          break;
        case "tagFuncionario":
          textContext = this.$t("seu_tag");
          break;
      }

      return textDefault + textContext;
    },
    cliente() {
      return this.$store.state.cliente.data || {};
    },
  },
  mounted() {
    const localLang = navigator.language.toLowerCase().replace("-", "_");

    if (
      !this.$store.state.language &&
      this.$store.state.languages.some((e) => e.flag === localLang)
    ) {
      this.$store.commit(
        "setLanguage",
        this.$store.state.languages.find((e) => e.flag === localLang)
      );
    } else if (!this.$store.state.language) {
      this.$store.commit("setLanguage", "en");
    }

    if (
      !this.$store.state.context ||
      (this.$store.state.context &&
        !this.$store.state[this.$store.state.context].session)
    ) {
      this.$router.push("/login");
    }
  },
  methods: {
    onCancel() {
      if (this.$store.state.context) {
        this.$store.commit(
          this.$store.state.context + "/setSession",
          undefined
        );
        this.$store.commit(this.$store.state.context + "/setUID", undefined);
      }
      this.$store.commit("setContext", undefined);

      this.$router.push("/login");
    },
    async signUp({ email, celular, password, terms, accept, idioma }) {
      return await this.$store.dispatch("auth/register", {
        uid: this.$store.state[this.$store.state.context].uid,
        email,
        celular,
        password,
        terms,
        accept,
        tipo: this.$store.state.context,
        session: this.$store.state[this.$store.state.context].session,
        idioma,
      });
    },
    response(res, err, { email, password }) {
      if (!res || !res.status || res.status >= 500)
        return err(this.$t("erro_desconhecido"));
      else if (!res || !res.status || res.status === 409) {
        err(this.$t("email_ja_cadastrado"));
      } else if (!res || !res.status || res.status === 403) {
        err(this.$t("sessao_expirou"));
        return this.$store.dispatch(this.$store.state.context + "/checkIn", {
          uid: this.$store.state[this.$store.state.context].uid,
          callbackSuccess: () => location.reload(),
          callbackError: () => err(this.$t("erro_tentar_regarregar_pagina")),
        });
      } else if (!res || !res.status || res.status >= 400) {
        return err(this.$t("dados_incorretos"));
      }

      if ([200, 201].includes(res.status)) {
        this.signIn({ email, password })
          .then((res) => this.responseSignIn(res))
          .catch((err) => this.responseSignIn(err.response));
      }
    },
    async signIn({ email, password }) {
      return await this.$store.dispatch("auth/login", {
        email,
        password,
      });
    },
    responseSignIn(res) {
      if (!res || !res.status || res.status >= 500 || res.status >= 400)
        return this.$router.push("/login");

      if (res.status === 200) {
        this.$store.commit("setContext", res.data.content.user.tipo);

        return this.$store.state.context === "pessoa"
          ? this.$router.push("/")
          : this.$router.push("/pet");
      }
    },
    async registerSignIn({ email, password }) {
      return await this.$store.dispatch("auth/registerLogin", {
        uid: this.$store.state[this.$store.state.context].uid,
        email,
        password,
        context: this.$store.state.context,
        session: this.$store.state[this.$store.state.context].session,
      });
    },
    responseRegisterSignIn(res, err) {
      if (!res || !res.status || res.status >= 500)
        return err(this.$t("erro_desconhecido"));
      else if (!res || !res.status || res.status === 409) {
        err(
          (this.$store.state.context === "pessoa"
            ? this.$t("O_bracelete")
            : this.$store.state.context === "pet"
            ? this.$t("O_pingente")
            : this.$store.state.context === "tagFuncionario"
            ? this.$t("O_Tag")
            : "") + this.$t("ja_esta_cadastrado")
        );
      } else if (!res || !res.status || res.status === 403) {
        err(this.$t("sessao_expirou"));
        return this.$store.dispatch(this.$store.state.context + "/checkIn", {
          uid: this.$store.state[this.$store.state.context].uid,
          callbackSuccess: () => location.reload(),
          callbackError: () => err(this.$t("erro_tentar_regarregar_pagina")),
        });
      } else if (!res || !res.status || res.status >= 400)
        return err(this.$t("usuario_senha_invalido_tente_novamente"));

      if (res.status === 200) {
        this.$store.commit("setContext", res.data.content.user.tipo);
        this.$store.commit(
          this.$store.state.context + "/setUID",
          res.data.content.user.uid
        );
        this.$store.commit("auth/setAccounts", []);

        switch (this.$store.state.context) {
          case "pessoa":
            return this.$router.push("/");
          case "pet":
            return this.$router.push("/pet");
          case "tagFuncionario":
            return this.$router.push("/tag");
        }
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
.login {
  &-card {
    min-height: 450px;
  }
}
</style>
